(function () {
  function syncSortLabel(select) {
    const label = select.closest('.coverax-facets-toolbar__sort-select')?.querySelector('.coverax-facets-toolbar__sort-value');
    const option = select.selectedOptions?.[0];

    if (label && option) {
      label.textContent = option.textContent.trim();
    }
  }

  function remapBestSellingSort(root = document) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('sort_by') !== 'best-selling') return;

    root.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      if (!select.querySelector('option[value="manual"]')) return;

      select.value = 'manual';
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function initCoveraxFacetsToolbar(root = document) {
    remapBestSellingSort(root);

    root.querySelectorAll('.coverax-facets-toolbar__sort-input').forEach((select) => {
      syncSortLabel(select);

      if (select.dataset.coveraxSortBound === 'true') return;

      select.dataset.coveraxSortBound = 'true';
      select.addEventListener('change', () => syncSortLabel(select));
    });
  }

  window.initCoveraxFacetsToolbar = initCoveraxFacetsToolbar;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCoveraxFacetsToolbar(), { once: true });
  } else {
    initCoveraxFacetsToolbar();
  }
})();
